import React, { useEffect, useState } from 'react';
import {
  getServiceTypes,
  createServiceType,
  updateServiceType,
  deleteServiceType,
} from '../services/serviceType.service';

import ServiceTypeForm from '../components/ServiceTypeForm';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const ServiceTypeList: React.FC = () => {
  const [serviceTypes, setServiceTypes] = useState<any[]>([]);
  const [selected, setSelected] = useState<any | null>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchServiceTypes = () => {
    getServiceTypes().then(res => setServiceTypes(res.data));
  };

  useEffect(() => {
    fetchServiceTypes();
  }, []);

  const handleCreate = () => {
    setSelected(null);
    setOpen(true);
  };

  const handleEdit = (serviceType: any) => {
    setSelected(serviceType);
    setOpen(true);
  };

  const handleDelete = (id: number) => {
    if (
      window.confirm(
        'Hide this service type? It will no longer appear for new cases but existing cases are unchanged.'
      )
    ) {
      deleteServiceType(id).then(fetchServiceTypes);
    }
  };

  const handleSubmit = (data: any) => {
    setLoading(true);
    if (selected) {
      updateServiceType(selected.id, data).then(() => {
        setOpen(false);
        setLoading(false);
        fetchServiceTypes();
      });
    } else {
      createServiceType(data).then(() => {
        setOpen(false);
        setLoading(false);
        fetchServiceTypes();
      });
    }
  };

  return (
    <div>
      <Typography variant='h4' gutterBottom>
        Service Types
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={handleCreate}
        sx={{ mb: 2 }}
      >
        Add Service Type
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Short Code</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Case Type</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Rush Tiers</TableCell>
              <TableCell>Attachments</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serviceTypes.map(st => (
              <TableRow key={st.id}>
                <TableCell>{st.name}</TableCell>
                <TableCell>{st.short_code}</TableCell>
                <TableCell>{st.description}</TableCell>
                <TableCell>
                  {st.case_type ? st.case_type : 'Both'}
                </TableCell>
                <TableCell>{st.price}</TableCell>
                <TableCell>
                  {st.rush_tiers && st.rush_tiers.length > 0
                    ? st.rush_tiers.map((t: any) =>
                        `${t.label}: ${t.min_days}–${t.max_days} days / $${Number(t.fee).toLocaleString()}`
                      ).join(' · ')
                    : <span style={{ color: '#999' }}>—</span>
                  }
                </TableCell>
                <TableCell>
                  {st.attachments?.map((a: any) => a.name).join(', ')}
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(st)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(st.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          {selected ? 'Edit Service Type' : 'Add Service Type'}
        </DialogTitle>
        <DialogContent>
          <ServiceTypeForm
            initialValues={selected || {}}
            onSubmit={handleSubmit}
            loading={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ServiceTypeList;
